export default __webpack_public_path__ + "static/autorizacao-menor-de-idade-4d59fadc5fe540167be9c9d5a1d745f5.pdf";